<template>
<div class="longform">
  <div class="longform-container">
    <h1 class="longform-header">
      Editor
    </h1>
    <textarea class="longform-edit"
      :placeholder="placeholder"
      ref="edit"
      @input="update($event.target.value)">{{ value }}</textarea>
  </div>
  <div class="longform-container longform-container--preview">
    <h1 class="longform-header">
      Preview
    </h1>
    <div class="longform-preview markdown-text" v-html="html" ref="preview">
    </div>
  </div>
</div>
</template>

<script>
import marked from 'marked';

export default {
  props: ['value', 'placeholder'],

  computed: {
    html(){ return marked(this.value || ''); }
  },

  methods: {
    update(newValue){
      this.$emit('input', newValue);
    }
  },

  mounted(){
    let edit = this.$refs.edit;
    let preview = this.$refs.preview;

    let editIsScrolling = false;
    let previewIsScrolling = false;

    edit.onscroll = () => {
      let editMax = edit.scrollHeight - edit.clientHeight;
      let previewMax = preview.scrollHeight - preview.clientHeight;
      if(!previewIsScrolling){
        editIsScrolling = true;
        let per = edit.scrollTop / editMax;
        preview.scrollTop = per * previewMax;
      }

      previewIsScrolling = false;

    }

    preview.onscroll = () => {
      let editMax = edit.scrollHeight - edit.clientHeight;
      let previewMax = preview.scrollHeight - preview.clientHeight;
      if(!editIsScrolling){
        previewIsScrolling = true;
        let per = preview.scrollTop / previewMax;
        edit.scrollTop = per * editMax;
      }

      editIsScrolling = false;
    }
  }
}
</script>



// WEBPACK FOOTER //
// longformeditor.vue?d3bf3870